var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabMallFocused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42609 6.76136C9.42609 4.56788 11.2658 2.41339 13.5527 2.20866C16.2767 1.95519 18.5738 4.0122 18.5738 6.57614",
    stroke: "#672C78",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97801 9.97452C3.95581 9.13093 4.63361 8.43506 5.47749 8.43506H22.5225C23.3664 8.43506 24.0442 9.13093 24.022 9.97452L23.7332 20.9473C23.6619 23.6565 21.4452 25.8157 18.735 25.8157H9.26504C6.55485 25.8157 4.33806 23.6565 4.26677 20.9473L3.97801 9.97452Z",
    fill: "#672C78",
    stroke: "#672C78",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6719 17.0041C16.3553 16.4779 16.7845 15.6372 16.7411 14.6974C16.6775 13.3137 15.5626 12.1788 14.1812 12.0896C12.5835 11.987 11.2557 13.2524 11.2557 14.8278C11.2557 15.7142 11.676 16.5013 12.3271 17.003C12.4152 17.071 12.5345 17.0788 12.6304 17.0242C13.034 16.7912 13.5011 16.6585 13.9995 16.6585C14.4979 16.6585 14.9661 16.7923 15.3697 17.0242C15.4656 17.0788 15.5849 17.071 15.6719 17.0041Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6728 17.2271C15.5848 17.1591 15.4655 17.1513 15.3696 17.2059C14.966 17.439 14.4988 17.5716 14.0005 17.5716C13.5021 17.5716 13.0338 17.4378 12.6302 17.2059C12.5344 17.1513 12.4151 17.1591 12.3281 17.226C11.6435 17.7522 11.2154 18.594 11.2589 19.5328C11.3236 20.9164 12.4374 22.0525 13.8187 22.1406C15.4164 22.2431 16.7443 20.9777 16.7443 19.4023C16.7443 18.516 16.324 17.7288 15.6728 17.2271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabMallFocused);
export default __webpack_public_path__ + "static/media/tab_mall_focused.8d13ce919c5f15300de2d8f481538346.svg";
export { ForwardRef as ReactComponent };